import { render } from "./TranslationSelector.vue?vue&type=template&id=3fd8f283&scoped=true"
import script from "./TranslationSelector.vue?vue&type=script&lang=js"
export * from "./TranslationSelector.vue?vue&type=script&lang=js"

import "./TranslationSelector.vue?vue&type=style&index=0&id=3fd8f283&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd8f283"]])

export default __exports__